/**
 * Cart Persistence Component
 *
 * Resets local cart state on logout. Login merge is handled by AuthStateMonitor
 * via syncCartAfterLogin. Server hydration is deferred until cart interaction.
 */

import { useEffect, useRef } from 'react';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { clearCart, setSessionId, GUEST_CART_ACTIVITY_KEY, invalidateCartSummaryCache } from '../../store/cartSlice';

function ensureGuestSessionId(): string {
  let sessionId = localStorage.getItem('cart_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
    localStorage.setItem('cart_session_id', sessionId);
  }
  return sessionId;
}

export function CartPersistence() {
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const prevAuthRef = useRef(isAuthenticated);

  useEffect(() => {
    const wasAuthenticated = prevAuthRef.current;
    if (wasAuthenticated && !isAuthenticated) {
      dispatch(clearCart());
      localStorage.removeItem(GUEST_CART_ACTIVITY_KEY);
      invalidateCartSummaryCache();
      dispatch(setSessionId(ensureGuestSessionId()));
    }
    prevAuthRef.current = isAuthenticated;
  }, [isAuthenticated, dispatch]);

  return null;
}
